import { useGetUserByEmailQuery } from "store/apis/usersApi";
import { selectUser } from "store/slices/session/sessionSelector";
import { setUserDb } from "store/slices/session/sessionSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useGetMyUserQuery = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const { data: userData } = useGetUserByEmailQuery(user?.email || "", {
    skip: !user?.email,
  });

  useEffect(() => {
    if (user && userData) {
      dispatch(setUserDb(userData));
    }
  }, [dispatch, user, userData]);
};
